export const SHOW_REQUEST_ERROR = 'SHOW_REQUEST_ERROR';
export const HIDE_REQUEST_ERROR = 'HIDE_REQUEST_ERROR';
export const GET_ALL_PROJECT = 'GET_ALL_PROJECT';

export const SHOW_REQUEST_SUCCESS = 'SHOW_REQUEST_ERROR';
export const HIDE_REQUEST_SUCCESS = 'HIDE_REQUEST_SUCCESS';

export const MAKE_COPY_MARKERS_AS_TEMPMARKERS =
  'MAKE_COPY_MARKERS_AS_TEMPMARKERS';

export const CLEAR_TEMPMARKERS = 'CLEAR_TEMPMARKERS';
export const REMOVE_MARKERS_FROM_TEMPMARKERS =
  'REMOVE_MARKERS_FROM_TEMPMARKERS';

export const SET_LOCATION = 'SET_LOCATION';
export const CLEAR_ALL_MARKERS = 'CLEAR_ALL_MARKERS';
export const GET_COVERED_LOCATION = 'GET_COVERED_LOCATION';
export const REMOVE_MARKER_FROM_MARKERS = 'REMOVE_MARKER_FROM_MARKERS';
export const GET_LOCATIONS_BY_PROJECT_ID = 'GET_LOCATIONS_BY_PROJECT_ID';
export const GET_LOCATIONS_BY_CUSTOMER_ID = 'GET_LOCATIONS_BY_CUSTOMER_ID';

export const CHANGE_RADIO_GROUP_TEXT = 'CHANGE_RADIO_GROUP_TEXT';
export const CHANGE_SLIDER_MODEL_VALUE = 'CHANGE_SLIDER_MODEL_VALUE';
export const SET_FILTERING_STATE_TO_DEFAULT = 'SET_FILTERING_STATE_TO_DEFAULT';
export const SET_SLIDER_FILTERING_DISABLED = 'SET_SLIDER_FILTERING_DISABLED';
export const SET_RADIOGROUP_FILTERING_DISABLED =
  'SET_RADIOGROUP_FILTERING_DISABLED';
export const SET_FILTERING_ELEMENT_DISABLED = 'SET_FILTERING_ELEMENT_DISABLED';

export const COPY_MARKERS_TO_TEMPMARKERS = 'COPY_MARKERS_TO_TEMPMARKERS';
export const COPY_NO_COVERAGE_MARKERS_TO_TEMPMARKERS =
  'COPY_NO_COVERAGE_MARKERS_TO_TEMPMARKERS';
export const COPY_COVERAGE_MARKERS_TO_TEMPMARKERS =
  'COPY_COVERAGE_MARKERS_TO_TEMPMARKERS';
export const SET_TEMP_MARKERS = 'SET_TEMP_MARKERS';
export const ADD_MARKER_TO_TEMPMARKERS = 'ADD_MARKER_TO_TEMPMARKERS';

export const SET_OVERLAY_DISPLAY = 'SET_OVERLAY_DISPLAY';
